import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

const ModalContent = styled('div')`
  display: flex;
  width: 100%;
  overflow: hidden;
  outline: none;
`;

/* Maintain a 16:9 aspect ratio so the frame hugs the video instead of
   letterboxing it inside a fixed-height container. */
const Container = styled('div')`
  position: relative;
  width: 100%;
  padding-top: 56.25%;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

const VideoModal = ({ url }) => (
  <ModalContent>
    <Container>
      <ReactPlayer
        className='react-player'
        url={url}
        controls
        width='100%'
        height='100%'
      />
    </Container>
  </ModalContent>
);

VideoModal.propTypes = {
  url: PropTypes.string.isRequired,
};

export default VideoModal;
